import { fetchAPI } from './apiClient';
import type { SettingsState, SettingsRecord } from '@/store/types';

export const settingsService = {

  async getSettings(): Promise<Partial<SettingsState>> {
    const record = await fetchAPI<SettingsRecord>('/api/settings/me/');
    return record.data ?? {};
  },
  async saveSettings(data: SettingsState): Promise<Partial<SettingsState>> {
    const record = await fetchAPI<SettingsRecord>('/api/settings/me/', {
      method: 'PATCH',
      body: JSON.stringify({ data }),
    });
    return record.data ?? {};
  },
};
